import { MapActions, MapCallbacks, MapState } from 'context/Map/types';
import { Reducer } from 'react';

function setZoom(state: MapState, payload: MapCallbacks['setZoom']): MapState {
    if (state.zoom === payload) {
        return state;
    }

    return {
        ...state,
        zoom: payload,
    };
}

function setCenter(state: MapState, payload: MapCallbacks['setCenter']): MapState {
    if (state.center.lat === payload.lat && state.center.lng === payload.lng) {
        return state;
    }

    return {
        ...state,
        center: payload,
    };
}

function setActiveMarkerUuid(state: MapState, payload: MapCallbacks['setActiveMarkerUuid']): MapState {
    if (state.activeMarkerUuid === payload) {
        return state;
    }

    return {
        ...state,
        activeMarkerUuid: payload,
    };
}

function setIsFitToBounds(state: MapState, payload: MapCallbacks['setIsFitToBounds']): MapState {
    if (state.isFitToBounds === payload) {
        return state;
    }

    return {
        ...state,
        isFitToBounds: payload,
    };
}

function setMapProvider(state: MapState, payload: MapCallbacks['setMapProvider']): MapState {
    if (state.mapProvider === payload) {
        return state;
    }

    return {
        ...state,
        mapProvider: payload,
    };
}

export const mapReducer: Reducer<MapState, MapActions> = (state, action): MapState => {
    switch (action.type) {
        case 'setZoom':
            return setZoom(state, action.payload);
        case 'setCenter':
            return setCenter(state, action.payload);
        case 'setActiveMarkerUuid':
            return setActiveMarkerUuid(state, action.payload);
        case 'setIsFitToBounds':
            return setIsFitToBounds(state, action.payload);
        case 'setMapProvider':
            return setMapProvider(state, action.payload);
        default:
            return state;
    }
};
